import React from 'react';

import { camelCaseToLabel } from 'utils';
export const MissingInfoDisplay = ({ info }) => {
  const capitalizedInfo = info.map((doc) => camelCaseToLabel(doc));
  return <>{capitalizedInfo.join(', ')}</>;
};
